import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/HeroSection.css';
import foot from '../../assets/foot.webp';
import crick from '../../assets/crick.webp';
import bask from '../../assets/basket.webp';
import valley from '../../assets/valley.webp';
import land from '../../assets/land.webp';
const heroSlides = [
  {
    id: 0,
    title: "Welcome to VernaEvents",
    subtitle: "🏆 Your Sports Hub",
    description: "India's premier platform for discovering, registering, and competing in sports events. Join thousands of athletes and teams across 10+ sports categories.",
    features: "📅 50+ Events | 👥 200+ Teams | 🏅 10+ Sports",
    buttonText: "Explore Events →",
    buttonLink: "/events",
    buttonSecondary: "About Us",
    buttonSecondaryLink: "/about",
    image: land,
    gradient: "linear-gradient(135deg, rgba(26, 26, 46, 0.65) 0%, rgba(15, 52, 96, 0.60) 100%)",
    isBrand: true
  },
  {
    id: 2,
    title: "The Crown Championship 2026 ⚽",
    subtitle: "Football Tournament",
    description: "5-a-side football tournament with exciting cash prizes. 16 teams battling for the championship!",
    date: "📅 July 27, 2026",
    venue: "📍 Elgin Turf, Kolkata",
    slots: "16 Teams | 7 Booked",
    buttonText: "Register Now →",
    buttonLink: "/events/2",
    image: foot,
    gradient: "linear-gradient(135deg, rgba(26, 26, 46, 0.65) 0%, rgba(45, 125, 70, 0.55) 100%)",
    isBrand: false
  },
  {
    id: 1,
    title: " Inter-College T20 Championship 🏏",
    subtitle: "Cricket Tournament",
    description: "Join the biggest inter-college cricket tournament. 8 teams competing for the prestigious trophy!",
    date: "📅 August 15, 2026",
    venue: "Will Updating Soon",
    slots: "8 Teams | Booking will start soon",
    buttonText: "Register Now →",
    buttonLink: "/events/1",
    image: crick,
    gradient: "linear-gradient(135deg, rgba(26, 26, 46, 0.65) 0%, rgba(26, 138, 63, 0.55) 100%)",
    isBrand: false
  },
  
  {
    id: 3,
    title: " State Level Basketball Cup 🏀",
    subtitle: "Basketball Tournament",
    description: "Professional basketball competition. 6 elite teams competing for the state championship!",
    date: "📅 September 10, 2026",
    venue: "Kolkata Indoor Stadium",
    slots: "6 Teams | Booking will start soon",
    buttonText: "View Details →",
    buttonLink: "/events/3",
    image: bask,
    gradient: "linear-gradient(135deg, rgba(26, 26, 46, 0.65) 0%, rgba(245, 130, 32, 0.55) 100%)",
    isBrand: false
  },
  {
    id: 4,
    title: " Beach Volleyball Tournament 🏐",
    subtitle: "Volleyball Tournament",
    description: "Open beach volleyball tournament with beachside experience. Teams of 5 players!",
    date: "📅 September 25, 2026",
    venue: "Will Updating Soon",
    slots: "10 Teams | Booking will start soon",
    buttonText: "Register Now →",
    buttonLink: "/events/4",
    image: valley,
    gradient: "linear-gradient(135deg, rgba(26, 26, 46, 0.65) 0%, rgba(0, 119, 190, 0.55) 100%)",
    isBrand: false
  }
];

function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const current = heroSlides[currentSlide];

  return (
    <section className="hero-section-wrapper">
      <div 
        className="hero-slide-wrapper"
        style={{
          backgroundImage: `url(${current.image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="hero-overlay" style={{ background: current.gradient }}></div>

        <div className="hero-content-wrapper">
          <div className="hero-text-wrapper">
            <span className={`hero-badge ${current.isBrand ? 'brand-badge' : ''}`}>
              {current.isBrand ? '🏆 VernaEvents' : current.subtitle}
            </span>

            <h1 className={`hero-title ${current.isBrand ? 'brand-title' : ''}`}>
              {current.title}
            </h1>

            <p className="hero-description">{current.description}</p>

            {current.isBrand && (
              <div className="hero-brand-features">
                <span className="brand-feature">📅 50+ Events</span>
                <span className="brand-feature">👥 200+ Teams</span>
                <span className="brand-feature">🏅 10+ Sports</span>
                <span className="brand-feature">⭐ 98% Satisfaction</span>
              </div>
            )}

            {!current.isBrand && (
              <div className="hero-meta-wrapper">
                <span className="hero-meta-item">{current.date}</span>
                <span className="hero-meta-item">{current.venue}</span>
                <span className="hero-meta-item">{current.slots}</span>
              </div>
            )}

            <div className="hero-buttons-wrapper">
              <Link to={current.buttonLink} className="hero-btn-primary">
                {current.buttonText}
              </Link>
              {current.isBrand ? (
                <Link to={current.buttonSecondaryLink} className="hero-btn-secondary">
                  {current.buttonSecondary}
                </Link>
              ) : (
                <Link to="/events" className="hero-btn-secondary">
                  View All Events →
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;